import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Button } from '@malash-office/ui-components';

interface PortalLogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * "יציאה" asks first, by request: the button sits beside "הזמנה חדשה" in the header, and a customer
 * who missed it by a few pixels was thrown back to the phone-and-code login.
 */
const PortalLogoutDialog = ({ open, onClose, onConfirm }: PortalLogoutDialogProps) => (
  <Dialog open={open} onClose={onClose} PaperProps={{ sx: { bgcolor: 'common.white' } }}>
    <DialogTitle>יציאה מהמערכת</DialogTitle>
    <DialogContent>
      <DialogContentText>האם אתה בטוח שברצונך לצאת?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Box sx={{ display: 'flex', gap: 1, p: 1 }}>
        <Button variant="text" fullWidth={false} onClick={onClose}>
          ביטול
        </Button>
        <Button variant="contained" fullWidth={false} onClick={onConfirm}>
          יציאה
        </Button>
      </Box>
    </DialogActions>
  </Dialog>
);

export default PortalLogoutDialog;
